module.exports = __webpack_public_path__ + "static/img/15.a54c4d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/15.png
// module id = Uvfa
// module chunks = 0